module.exports = __webpack_public_path__ + "static/media/KV02.55b2ec1f.jpg";